import { ViewListItem } from "@ext/markdown/elements/view/render/components/Displays/Helpers/List/ListItem";
import getGroupTitle from "@ext/properties/logic/grouping/getGroupTitle";
import type { Property, PropertyID, ViewRenderData, ViewRenderGroup } from "@ext/properties/models";
import { Fragment, type ReactNode } from "react";

interface RenderGroupProps {
	group: ViewRenderGroup;
	catalogProperties: Map<PropertyID, Property>;
	disabled?: boolean;
	onSubmit?: (article: string, groups: string[], propertyName: string, value: string, isDelete?: boolean) => void;
	isPrint?: boolean;
	parentGroups?: string[];
}

const renderGroup = (props: RenderGroupProps): ReactNode => {
	const { group, catalogProperties, disabled, onSubmit, isPrint, parentGroups = [] } = props;

	const listItems = group.articles.map((article: ViewRenderData) => (
		<ViewListItem
			article={article}
			disabled={disabled}
			isPrint={isPrint}
			key={article.itemPath}
			onSubmit={onSubmit}
			parentGroups={parentGroups}
		/>
	));

	const renderSubgroups = () =>
		group.subgroups?.map((subgroup) => (
			<Fragment key={`${subgroup.group?.[0]}-list-item`}>
				{renderGroup({
					...props,
					group: subgroup,
					parentGroups: [...parentGroups, group.group?.[0]],
				})}
			</Fragment>
		));

	if (!group.group?.length)
		return (
			<>
				{listItems}
				{renderSubgroups()}
			</>
		);

	return (
		<li>
			<div>{getGroupTitle(group, catalogProperties)}</div>
			{listItems.length > 0 && <ul>{listItems}</ul>}
			{group.subgroups?.length > 0 && <ul>{renderSubgroups()}</ul>}
		</li>
	);
};

export default renderGroup;
